import { render, staticRenderFns } from "./AceitarAtivacao.vue?vue&type=template&id=60a3979e&"
import script from "./AceitarAtivacao.vue?vue&type=script&lang=js&"
export * from "./AceitarAtivacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports